export default __webpack_public_path__ + "static/media/mprojectfeature3.bc99e2b8.png";